export const API = import.meta.env.VITE_API_URL ?? '/api';
